import { type ReactNode } from "react";
import { Label } from "@/components/ui/label";

export function PhotoField({
  label, required, children,
}: {
  label: string;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <div>
      <Label className="mb-1.5 flex items-center gap-1.5 text-slate-700">
        <span>{label}</span>
        {required && <span className="text-destructive">*</span>}
      </Label>
      {children}
    </div>
  );
}
